module.exports = __webpack_public_path__ + "static/media/logoTitle.17b67ecc.png";